<template>
  <div>
    <CRow>
      <CCol col>
        <CCard>
          <CCardHeader>
            <strong> Modulo de Tipo de Habitaciones - Listar</strong>
          </CCardHeader>
          <CCardBody>
            <b-row>
              <b-col sm="12" md="8"></b-col>
       
              <b-col sm="6" md="3">
                <b-input-group>
                  <b-form-input  v-model="search" class="form-control"></b-form-input>
                  <b-input-group-append>
                    <b-button variant="primary" @click="ListRoomType"><b-icon icon="search"></b-icon></b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-col>
              <b-col sm="6" md="1">
                <b-link v-if="Permission('RoomTypeAdd')" class="btn form-control btn-primary" :to="{ path: '/tipo-habitacion/nuevo' }" append><i class="fas fa-file"></i></b-link>
              </b-col>
            </b-row>
            <div  class="table-responsive mt-3 height-table">
              <table class="table table-hover table-bordered">
                <thead>
                  <tr>
                    <th width="5%" class="text-center">#</th>
                    <th width="10%" class="text-center">Código</th>
                    <th width="45%" class="text-center">Nombre</th>
                    <th width="10%" class="text-center">Nro Huespedes</th>
                    <th width="10%" class="text-center">Foto</th>
                    <th width="10%" class="text-center">Estado</th>
                    <th width="10%" class="text-center">Acciones</th>
                  </tr>
                </thead>
                <tbody v-for="(item, it) in data_table" :key="it">
                  <tr>
                    <td class="text-center">{{ it + 1 }}</td>
                    <td class="text-center"> {{ item.code }}</td>
                    <td class="text-left"> {{ item.name }}</td>
                    <td class="text-left"> {{ item.number_guests }}</td>
                    <td class="text-left">
                      <b-card-img :src="url_base + item.photo"></b-card-img>
                    </td>
                    <td class="text-center">
                      <b-badge v-if="item.state == 1" variant="success">Activo</b-badge>
                      <b-badge v-if="item.state == 0" variant="danger">Inactivo</b-badge>
                    </td>
                    <td class="text-center">
                      <b-dropdown bloque size="sm" text="Acciones" right>
                        <b-dropdown-item v-if="Permission('RoomTypeEdit')" @click="EditRoomType(item.id_room_type)">Editar</b-dropdown-item>
                        <b-dropdown-item v-if="Permission('RoomTypeView')" @click="ViewRoomType(item.id_room_type)">Ver</b-dropdown-item>
                        <b-dropdown-item v-if="Permission('RoomTypeDelete')" @click="ConfirmDeleteRoomType(item.id_room_type)">Eliminar</b-dropdown-item>
                      </b-dropdown>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
        

            <b-row class="mt-4">
              <b-col md="8">
                <b-pagination
                  v-model="currentPage"
                  v-on:input="ListRoomType"
                  :total-rows="rows"
                  :per-page="perPage"
                  align="center"
                ></b-pagination>
              </b-col>
              <b-col md="4 text-center">
                <p>Pagina Actual: {{ currentPage }}</p>
              </b-col>
            </b-row>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
const axios = require("axios").default;
const Swal = require("sweetalert2");
const je = require("json-encrypt");
import { mapState } from "vuex";

export default {
  name: "UsuarioList",
  data() {
    return {
      module:'RoomType',
      perPage: 15,
      currentPage: 1,
      rows: 0,
      search: "",
      data_table: [],
    };
  },
  mounted() {
    this.ListRoomType();
  },
  methods: {
    ListRoomType,
    EditRoomType,
    ViewRoomType,
    ConfirmDeleteRoomType,
    DeleteRoomType,
    Permission,
  },

  computed: {
    ...mapState(["url_base"]),
    token: function () {
      let user = window.localStorage.getItem("user");
      user = JSON.parse(JSON.parse(je.decrypt(user)));
      return user.api_token;
    },
  },
};

//listar usuario
function ListRoomType() {
  let search = this.search == "" ? "all" : this.search;
  let me = this;
  let url =
    this.url_base + "room-type/list/" + search + "?page=" + this.currentPage;

  axios({
    method: "GET",
    url: url,
    headers: { token: this.token, module: this.module, role: 1,},
  })
    .then(function (response) {
      if (response.data.status == 200) {
        me.rows = response.data.result.total;
        me.data_table = response.data.result.data;
      } else {
        Swal.fire({ icon: 'error', text: 'A ocurrido un error', timer: 3000,})
      }
    })
    .catch((error) => {
      Swal.fire({ icon: 'error', text: 'A ocurrido un error', timer: 3000,})
    });
}

// Editar usuario
function EditRoomType(id_room_type) {
  this.$router.push({
    name: "RoomTypeEdit",
    params: { id_room_type: je.encrypt(id_room_type) },
  });
}

// Ver Usuario
function ViewRoomType(id_room_type) {
  this.$router.push({
    name: "RoomTypeView",
    params: { id_room_type: je.encrypt(id_room_type) },
  });
}

function ConfirmDeleteRoomType(id_room_type) {
  Swal.fire({
    title: "Esta seguro de eliminar el tipo de habitación?",
    text: "No podrás revertir esto!",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Si, Estoy de acuerdo!",
  }).then((result) => {
    if (result.value) {
      this.DeleteRoomType(id_room_type);
    }
  });
}

// eliminar usuario
function DeleteRoomType(id_room_type) {
  let me = this;
  let url = this.url_base + "room-type/delete/" + id_room_type;
  axios({
    method: "delete",
    url: url,
    headers: {
      token: this.token,
      module: this.module,
      role: 4,
    },
  })
    .then(function (response) {
      if (response.data.status == 200) {
        //eliminado del objeto
        for (var i = 0; i < me.data_table.length; i++) {
          if (me.data_table[i].id_room_type == id_room_type) {
            me.data_table.splice(i, 1);
            break;
          }
        }
        Swal.fire({ icon: 'success', text: 'La habitacion ha sido eliminada ha sido elimimado', timer: 3000,})
      } else {
        Swal.fire({ icon: 'error', text: response.data.message, timer: 3000,})
      }
    })
    .catch((error) => {
      Swal.fire({ icon: 'error', text: 'A ocurrido un error', timer: 3000,})
    });
}

// permisos
function Permission(module_permission) {
  let user_permissions = window.localStorage.getItem("user_permissions");
  user_permissions = JSON.parse(JSON.parse(je.decrypt(user_permissions)));
  if (user_permissions.indexOf(module_permission) > -1) {
    return true;
  } else {
    return false;
  }
}
</script>
